import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable, of, throwError, iif } from 'rxjs';
import { catchError, concatMap, delay, mergeMap, retryWhen, tap } from 'rxjs/operators';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { DisplayErrorService } from './display-error/display-error.service';
import { inject } from '@angular/core';

export const retryCount = 3;
export const retryDelay = 1000;
let stop: boolean = false;

export const coreInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
    let newReq = req.clone();

    let fuseConfirmationService = inject(FuseConfirmationService);
    let displayErrorService = inject(DisplayErrorService);

    return next(newReq).pipe(
        retryWhen(error =>
            error.pipe(
                concatMap((error, count) => {
                    if (!stop) {
                        // set show error 500 page to false
                        displayErrorService.hide();

                        const substring = String(error.status)[0]

                        // retry 'retryCount' amount of times
                        if (count < retryCount && error instanceof HttpErrorResponse && (substring === '5' || substring === '0')) {
                            stop = true;
                            return of(error);
                        }

                        // when already retried 'retryCount' amount of times
                        else if (count === retryCount) {
                            let title = "Internal Server Error";
                            if (error.status === 0) {
                                title = "Page Not Found !"
                            }
                            if (!navigator.onLine) {
                                error.status = "502"
                                title = "No Internet Connection"
                            }
                            displayErrorService.show({ title, code: error.status === 0 ? '404' : error.status.toString(), message: error.message, type: '5xx', aftereffect: 'reload' });
                        }

                        // Ignore intercept for login () clients/authenticate
                        else if (error instanceof HttpErrorResponse && !(error.status === 401 && newReq.url.indexOf("user/signin") > -1) && !(error.status === 409) && !(error.status === 400) && !(error.status === 417) && !(error.status === 404) && !(error.status === 403)) {
                            // Show a error message
                            const confirmation = fuseConfirmationService.open({
                                title: error.error.error ? 'Error ' + error.error.error + ' (' + error.error.status + ')' : 'Error',
                                message: error.error.message ? error.error.message : error.message,
                                icon: {
                                    show: true,
                                    name: "heroicons_outline:exclamation-triangle",
                                    color: "warn"
                                },
                                actions: {
                                    confirm: {
                                        label: 'OK',
                                        color: "primary",
                                    },
                                    cancel: {
                                        show: false,
                                    },
                                }
                            });
                        }

                        return throwError(() => error);

                    } else {
                        let title = "Internal Server Error";
                        if (error.status === 0) {
                            title = "Page Not Found !"
                        }
                        if (!navigator.onLine) {
                            error.status = "502"
                            title = "No Internet Connection"
                        }
                        displayErrorService.show({ title, code: error.status === 0 ? '404' : error.status.toString(), message: error.message, type: '5xx', aftereffect: 'reload' });
                    }
                }),

                // delay the retry
                delay(retryDelay)
            )
        ),
    );
}
